export default "__VITE_ASSET__28e67308__"